<template>
   <div class='TerminadosEmp'>
    
    <div v-if="loading">
        <div class="d-flex justify-content-center mt-5">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div> 
    <div v-else>
        <div v-if="projectos == null">
            <div class="row pt-3">
                <div class="col">
                    <div class="card">
                        <p class="text-center pt-2">Sin Proyectos</p>
                    </div>
                </div>
            </div>
         </div>
        <div v-else>
            <!-- Tabla -->
            <table class="table">
            <thead>
                <tr>
                    <th scope="col">Nombre Proyecto</th>
                    <th>Adjudicado a:</th>
                    <th>Fecha</th>
                    <th scope="col">Mi Evaluacion</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="f in projectos" :key="f.id">
                    <td>
                        <router-link :to="{ name: 'DetalleProyecto', params: { idEmpresa: f.id_proyecto}}"> 
                            {{f.titulo_proyecto}} 
                        </router-link>
                    </td>
                    <td>
                        <div class="row">
                            <div class="col-sm-2">
                                <img :src="getUrl(f.avatar)" class="img">
                            </div>
                            <div class="col-sm-10">
                                <router-link :to="{ name: 'calificacion', params: {id: f.id_user}}">
                                    @{{f.usuario}}
                                </router-link>
                                <star-rating :increment="0.1" :rating="makeNumber(f.estrellas)" :star-size="20" :show-rating="false" :read-only="true"/>
                            </div>
                        </div>
                    </td>
                    <td>{{fechaFormat(f.fecha)}}</td>
                    <td>
                        <button class="btn btn-sm btn-primary" 
                                @click="preCarga(f)" 
                                data-toggle="modal" 
                                data-target='#modalRating'
                                v-if="f.calificacionE == 0"
                        >
                            Calificar
                        </button>
                        <p v-else>
                            <star-rating :increment="0.1" :rating="makeNumber(f.calificacionE)" :star-size="20" :show-rating="true" :read-only="true"/>
                        </p>
                    </td>
                </tr>
            </tbody>
            </table>
        </div>
    </div>


    <!--Modal Calificar -->
    <div class="modal fade" id="modalRating" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">Califica a: {{usuario}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form @submit="calificacion">
                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-9">
                            <p>¿Que tan satisfecho estás con la <b> Fiabilidad </b> del Consultor en tu proyecto?</p>
                        </div>
                        <div class="col-sm-2">
                            <star-rating :increment="0.1" :rating="makeNumber(rating_f)" v-model="rating_f" :star-size="20" :show-rating="true" :read-only="false"/>
                        </div>
                        <div class="col-sm-1">
                            <button type="button" class="float-right btn btn-dark btn-sm pt-0 pb-0 pl-1 pr-1" data-toggle="tooltip" data-placement="right" :title="tooltip_f">
                                ?
                            </button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-9">
                            <p>¿Que tan satisfecho estas con el nivel de  <b>Conocimiento </b> demostrado por el consultor?</p>
                        </div>
                        <div class="col-sm-2">
                            <star-rating :increment="0.1" :rating="makeNumber(rating_c)" v-model="rating_c" :star-size="20" :show-rating="true" :read-only="false"/>
                        </div>
                        <div class="col-sm-1">
                            <button type="button" class="float-right btn btn-dark btn-sm pt-0 pb-0 pl-1 pr-1" data-toggle="tooltip" data-placement="right" :title="tooltip_c">
                                ?
                            </button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-9">
                            <p>¿Que tan satisfecho estas con la <b>Empatía</b> mostrada por el Consultor?</p>
                        </div>
                        <div class="col-sm-2">
                            <star-rating :increment="0.1" :rating="makeNumber(rating_e)" v-model="rating_e" :star-size="20" :show-rating="true" :read-only="false"/>
                        </div>
                        <div class="col-sm-1">
                            <button type="button" class="float-right btn btn-dark btn-sm pt-0 pb-0 pl-1 pr-1" data-toggle="tooltip" data-placement="right" :title="tooltip_e">
                                ?
                            </button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-9">
                            <p>¿Que tan satisfecho estas con el manejo del Consultor a la <b>Seguridad</b> requerida para tu proyecto?</p>
                        </div>
                        <div class="col-sm-2">
                            <star-rating :increment="0.1" :rating="makeNumber(rating_s)" v-model="rating_s" :star-size="20" :show-rating="true" :read-only="false"/>
                        </div>
                        <div class="col-sm-1">
                            <button type="button" class="float-right btn btn-dark btn-sm pt-0 pb-0 pl-1 pr-1" data-toggle="tooltip" data-placement="right" :title="tooltip_s">
                                ?
                            </button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-9">
                            <p>¿Que tan satisfecho esta con la <b>Sensibilidad</b> con la que actuó el Consultor?</p>
                        </div>
                        <div class="col-sm-2">
                            <star-rating :increment="0.1" :rating="makeNumber(rating_ss)" v-model="rating_ss" :star-size="20" :show-rating="true" :read-only="false"/>
                        </div>
                        <div class="col-sm-1">
                            <button type="button" class="float-right btn btn-dark btn-sm pt-0 pb-0 pl-1 pr-1" data-toggle="tooltip" data-placement="right" :title="tooltip_ss">
                                ?
                            </button>
                        </div>
                    </div>

                    <hr>
                    <p>Por favor de alguna sugerencia de mejora o comentario que pueda ayudar al Consultor para seguir mejorando su desempeño y elevar su reputacion.</p>
                    
                    <textarea class="form-control" v-model="resena" maxlength="280" required placeholder="Comentarios...." rows="4"></textarea>

                    <div class="row pt-2">
                        <div class="col-sm-8">
                            <h2> Calificacion: </h2> 
                        </div>
                        <div class="col-sm-4">
                            <star-rating :increment="0.1" :rating="makeNumber(rating_total)" v-model="rating_total" :star-size="40" :show-rating="true" :read-only="true"/>
                        </div>
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    <button type="submit" class="btn orange"> Aceptar </button>
                </div>
            </form>
            </div>
        </div>
    </div>

   </div>
</template>


<script>
import $ from 'jquery'
import { mapState } from 'vuex'
import { globalFunctions } from '@/hooks/globalFunctions'
import StarRating from 'vue-star-rating'

export default {
name: 'TerminadosEmp',
mixins: [ globalFunctions ],
components:{ StarRating },
data () {
    return {
        projectos: [],
        loading: true,
        rating: 0,
        resena: '',
        idSolicitante: '',
        idProyecto: '',
        usuario: '',
        rating_total: 0,
        rating_f: 0,
        rating_e: 0,
        rating_c: 0,
        rating_s: 0,
        rating_ss: 0,
        tooltip_f: 'Se refiere a la habilidad para ejecutar el servicio prometido de forma  fiable y cuidadosa. Es decir, que el Consultor cumple con sus promesas, sobre entregas, suministro del servicio, solución de problemas y fijación de precios.',
        tooltip_c: 'Capacidad para ofrecer alternativas válidas para su empresa y su entorno. Estas alternativas deben ser innovadoras, útiles, prácticas y concretas, con una clara justificación de sus génesis y su factibilidad e idoneidad.',
        tooltip_e: 'Se refiere al nivel de atención individualizada que ofrece el Consultor a sus clientes. Se debe transmitir por medio de un servicio personalizado o adaptado al gusto del cliente.',
        tooltip_s: 'Es el conocimiento y atención del Consultor y su habilidad para inspirar credibilidad, confianza, resguardar y proteger la información buscando mantener la confidencialidad, la disponibilidad e integridad de datos.',
        tooltip_ss: 'Es la disposición para ayudar y para prestarle un servicio rápido y adecuado. Se refiere a la atención y prontitud al tratar las solicitudes, responder preguntas y quejas, y solucionar problemas.'
    }
},
methods: {
    getData(){
        let data = {
            id: localStorage.userID,
            prop: 5,
            flag:0
        };
    
        this.axios.post(this.url + 'getProyectos.php',data).then((responce) =>{
            this.projectos = responce.data;
            this.loading = false
        });
    },

    preCarga(f){
        this.usuario = f.usuario;
        this.idSolicitante = f.id_user;
        this.idProyecto = f.id_proyecto;
    },

    sumar_cal(){
        let total = 0;
        total = this.rating_f + this.rating_c + this.rating_e + this.rating_s + this.rating_ss;
        total = total / 5;
        this.rating_total = total;
    },

    calificacion(e){
        e.preventDefault();
        
        if(this.rating_e == 0 || this.rating_c == 0 || this.tooltip_f == 0 || this.rating_s == 0 || this.rating_ss == 0 ){
            alert("Debe llenar todos los campos.");
            return;
        }

        let data = {
            quien: localStorage.userID,
            rol: localStorage.rol,
            flag: 2,
            estrella: this.rating_total,
            resena: this.resena,
            encargado: this.idSolicitante,
            idProyecto: this.idProyecto
        };
        
        this.axios.post(this.url + 'postProyectos.php',data).then((responce) =>{
            this.rating = 0;
            this.rating_total = 0;
            this.rating_e = 0;
            this.rating_c = 0;
            this.tooltip_f = 0;
            this.tooltip_s = 0;
            this.tooltip_ss = 0;
            this.resena = "";
            this.getData();
            $('#modalRating').modal('hide');
        });
    }
},
computed:{
    ...mapState(['url'])
},
watch:{
    rating_f(){
        this.sumar_cal();
    },
    rating_c(){
        this.sumar_cal();
    },
    rating_e(){
        this.sumar_cal();
    },
    rating_s(){
        this.sumar_cal();
    },
    rating_ss(){
        this.sumar_cal();
    }
},
mounted(){
    this.getData();

    $('#modalRating').on('shown.bs.modal', function (event) {
        $('[data-toggle="tooltip"]').tooltip();
    })
}
}
</script>


<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/Proyectos/components/Empresa/TerminadosEmp.vue